import React, { useEffect, useState, useRef } from "react";
import { Button } from "@/app/global-components/button"; // Ensure this path is correct
import { ImSpinner2 } from "react-icons/im";
import { Snackbar, Alert } from "@mui/material";
import { useTranslate } from "@/locales";
import { useLocale } from "@/middleware";

interface SaveTenderSubmitViewProps {
  isLoading: boolean;
  onClick: () => void;
}

const OrderQuatationSubmit: React.FC<SaveTenderSubmitViewProps> = ({
  isLoading,
  onClick,
}) => {
  const { locale } = useLocale();
  const { t } = useTranslate(locale);
  const [showSnackbar, setShowSnackbar] = useState(false);
  const prevIsLoadingRef = useRef<boolean | null>(null);

  useEffect(() => {
    if (prevIsLoadingRef.current && !isLoading) {
      setShowSnackbar(true);
    }
    prevIsLoadingRef.current = isLoading;
  }, [isLoading]);

  const handleCloseSnackbar = () => {
    setShowSnackbar(false);
  };

  const handleClick = () => {
    if (!isLoading) {
      onClick();
    }
  };

  return (
    <div>
      <Button
        className="flex items-center bg-secondary-brightYellow shadow text-textcolor-black w-full py-2 px-4 text-sm" style={{background:'#000',color:"#fff"}}
        onClick={handleClick}
        disabled={isLoading}
      >
        {isLoading ? (
          <>
            <span className="ml-2 animate-spin">
              <ImSpinner2 />
            </span>
            {t("actions.creatingOrder")}
          </>
        ) : (
          t("actions.createOrder")
        )}
      </Button>

      <Snackbar
        open={showSnackbar}
        autoHideDuration={3000}
        onClose={handleCloseSnackbar}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <Alert
          onClose={handleCloseSnackbar}
          severity="success"
          sx={{ width: "100%" }}
        >
          {t("alerts.success.orderCreatedSuccess")}
        </Alert>
      </Snackbar>
    </div>
  );
};

export default OrderQuatationSubmit;
